export default __webpack_public_path__ + "static/media/fb.e9023412.svg";